<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="#"></b-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <!--<b-navbar-nav class="d-md-down-none">
      <b-nav-item class="px-3"><i class="fa fa-calendar"></i></b-nav-item>
      <b-nav-item class="px-3"><i class="fa fa-envelope-o"></i></b-nav-item>
    </b-navbar-nav>-->
    <b-navbar-nav class="ml-auto">
     <!-- <div class="header-language">
        <change-language></change-language>
      </div>-->
      <HeaderDropdownAccnt/>
    </b-navbar-nav>
  </header>
</template>

<style>
  .header-language {
    margin-top: 16px;
  }
  .header-language select {
    height: 35px !important;
    width: 100px;
  }
  .header-search {
    width: 400px;
  }
</style>

<script>
  import HeaderDropdownAccnt from './HeaderDropdownAccnt.vue'
  import ChangeLanguage from '../../components/Partials/ChangeLangues.vue'

  export default {
    name: 'main-header',
    components: {
      HeaderDropdownAccnt
    },
    methods: {
      sidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-hidden')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/Header.vue